module.exports = __webpack_public_path__ + "static/media/4-insert-product.68b05d30.mp4";